import { Textarea, TextareaProps } from "@headlessui/react";

function TextArea({ className, ...rest }: TextareaProps) {
    return (
        <Textarea
            className={`rounded-md shadow-sm border-gray-300 focus:border-gray-300 focus:ring-3 focus:ring-gray-200/50 ${
                className ?? ""
            }`}
            {...rest}
        />
    );
}

export default TextArea;
